export const MAX_MEAL_SUGGESTION_PHOTOS = 4;
export const MAX_MEAL_SUGGESTION_PHOTO_BYTES = 8 * 1024 * 1024;
export const SUPPORTED_MEAL_SUGGESTION_PHOTO_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
]);

const photoKey = (file) => [file?.name, file?.size, file?.type, file?.lastModified].join(':');

export function addMealSuggestionPhotos(currentEntries, incomingFiles, createObjectURL = URL.createObjectURL) {
  const entries = [...(currentEntries || [])];
  const feedback = [];
  const seen = new Set(entries.map(entry => photoKey(entry.file)));

  for (const file of Array.from(incomingFiles || [])) {
    if (!SUPPORTED_MEAL_SUGGESTION_PHOTO_TYPES.has(file?.type)) {
      feedback.push(`${file?.name || 'Photo'} has an unsupported image type.`);
      continue;
    }
    if (Number(file?.size || 0) > MAX_MEAL_SUGGESTION_PHOTO_BYTES) {
      feedback.push(`${file?.name || 'Photo'} is larger than 8 MB.`);
      continue;
    }
    const key = photoKey(file);
    if (seen.has(key)) {
      feedback.push(`${file.name || 'Photo'} is already attached.`);
      continue;
    }
    if (entries.length >= MAX_MEAL_SUGGESTION_PHOTOS) {
      feedback.push(`You can attach up to ${MAX_MEAL_SUGGESTION_PHOTOS} ingredient photos.`);
      continue;
    }
    seen.add(key);
    entries.push({ file, previewUrl: createObjectURL(file) });
  }

  return { entries, feedback };
}

export function removeMealSuggestionPhoto(entries, index, revokeObjectURL = URL.revokeObjectURL) {
  const removed = entries?.[index];
  if (!removed) return [...(entries || [])];
  revokeObjectURL(removed.previewUrl);
  return entries.filter((_, entryIndex) => entryIndex !== index);
}

export function resetMealSuggestionPhotos(entries, revokeObjectURL = URL.revokeObjectURL) {
  (entries || []).forEach(entry => revokeObjectURL(entry.previewUrl));
  return [];
}
